import {
    Button,
    PanelBody,
    Flex,
    FlexItem,
    BaseControl,
} from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { fieldComponents, defaultValues } from '../fieldComponents';
import { checkConditionalLogic } from '../../utils/ConditionalLogicChecker';

const RepeaterControl = ({ field, value = [], onChange }) => {
    
    const repeaterValues = Array.isArray(value) ? value : [];

    const handleFieldChange = (index, metaKey, newValue) => {
        const updated = [...repeaterValues];
        updated[index] = {
            ...updated[index],
            [metaKey]: newValue,
        };
        onChange(updated);
    };

    const handleAddRow = () => {
        const newRow = {};
        field.fields.forEach((subField) => {
            newRow[subField.field_key] = subField.default_value ?? '';
        });
        onChange([...repeaterValues, newRow]);
    };

    const handleRemoveRow = (index) => {
        const updated = [...repeaterValues];
        updated.splice(index, 1);
        onChange(updated);
    };

    return (
        <div className="voxy-repeater">
            <BaseControl label={field.label} __nextHasNoMarginBottom>
                {repeaterValues.length > 0 ? (
                    repeaterValues.map((item, index) => (
                        <PanelBody
                            title={`${field.label} #${index + 1}`}
                            key={index}
                            initialOpen={false}
                        >
                            {field.fields.map((subField) => {
                                if (!checkConditionalLogic(item, subField.conditional_logic)) {
                                    return null;
                                }

                                const SubFieldComponent = fieldComponents[subField.type] || fieldComponents.text;

                                const subValue =
                                    item[subField.field_key] ?? (defaultValues[subField.type] || '');

                                return (
                                    <div key={subField.field_key} style={{ marginBottom: '15px' }}>
                                        <SubFieldComponent
                                            field={subField}
                                            value={subValue}
                                            onChange={(newValue) =>
                                                handleFieldChange(index, subField.field_key, newValue)
                                            }
                                        />
                                    </div>
                                );
                            })}
                            <Flex justify="end">
                                <FlexItem>
                                    <Button
                                        variant="secondary"
                                        isDestructive
                                        onClick={() => handleRemoveRow(index)}
                                    >
                                        {__('Remove', 'voxycure-framework')}
                                    </Button>
                                </FlexItem>
                            </Flex>
                        </PanelBody>
                    ))
                ) : (
                    <div style={{ padding: '10px' }}>
                        <em>{__('No entries yet. Click "Add New" to create one.', 'voxycure-framework')}</em>
                    </div>
                )}
                <Button variant="primary" onClick={handleAddRow} style={{ marginTop: '15px' }}>
                    {__('Add New', 'voxycure-framework')}
                </Button>
            </BaseControl>
        </div>
    );
};

export default RepeaterControl;
